import { Button, Card } from "react-bootstrap";

export default function ETH() {
  return <div>
    <Card>
      <Card.Body>
        <Card.Title>ETH</Card.Title>
        <Card.Text>
          For ETH, we are using the Sepolia network, you may use the below faucet. Requires login
        </Card.Text>

        <ul>
          <li>
            <Button variant="link">
              <a href="https://www.alchemy.com/faucets/ethereum-sepolia">ETH Faucet (Requires Google Login)</a>
            </Button>
          </li>
          <li>
            <Button variant="link">
              <a href="https://sepolia-faucet.pk910.de/">POW ETH Faucet</a>
            </Button>
          </li>
          <li>
            <Button variant="link">
              <a href="https://www.alchemy.com/faucets/arbitrum-sepolia">Arbitrum ETH</a>
            </Button>
            (Requires Arb Mainnet balance)
          </li>
          <li>
            <Button variant="link">
              <a href="https://faucets.chain.link/base-sepolia">BASE ETH</a>
            </Button>
            (Requires ETH Mainnet balance of 1 LINK)
          </li>
          <li>
            <Button variant="link">
              <a href="https://faucet.testnet.chain.robinhood.com">Robinhood Chain ETH</a>
            </Button>
            (DO NOT send directly to a shuffle deposit address, use metamask in between)
          </li>
        </ul>
      </Card.Body>
    </Card>
  </div>
}